export async function fetcher<T = unknown>(
  url: string,
  options?: RequestInit
): Promise<T> {
  const res = await fetch(url, options)

  // Tente de parser le JSON uniquement si pertinent
  const ct = res.headers.get('content-type') ?? ''
  let data: unknown = undefined
  if (ct.includes('application/json')) {
    try {
      data = await res.json()
    } catch {
      // ex: body vide ou JSON invalide → on laisse data = undefined
    }
  }

  if (!res.ok) {
    const msg =
      getStringProp(data, 'message') ??
      getStringProp(data, 'error') ??
      `${res.status} ${res.statusText || 'An error occurred'}`

    throw new Error(msg)
  }

  // À ce stade, l’appelant sait quel type attendre (T)
  return data as T
}

/* Utils de narrowing */
function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null
}

function getStringProp(v: unknown, key: string): string | undefined {
  if (!isRecord(v)) return undefined
  const val = v[key]
  return typeof val === 'string' ? val : undefined
}
